<div class="ui-dialog-content" style="padding: 0;">
  <div class="ui-g">
    <div class="ui-g-12 ui-md-6">
      <p>{{ 'customerSetBuilder.queryResultMsg' | translate:{queryResult: results} }}</p>
    </div>
  </div>
</div>
<div class="ui-dialog-footer">
  <button
    type="button"
    pButton
    class="ui-button-success btnDelete"
    icon="fa fa-file-excel-o"
    (click)="exportResults()"
    label="{{ 'customerSetBuilder.exportResults' | translate }}"
    [disabled]="results < 1">
  </button>
  <button
    type="button"
    pButton
    class="ui-button-danger btnDelete"
    icon="fa fa-close"
    (click)="onCloseDialog.emit()"
    label="{{ 'common.cancel' | translate }}">
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-builder/customer-set-results/customer-set-results.component.html